import IconButton from "../iconButton/IconButton";
import "./PainAssessmentToolSelector.css";
import { getAllTools } from "./painAssesmentConfig";

const PainAssesmentToolSelector = ({
  selectedTool,
  onToolSelect,
  isDisabled = false,
}) => {
  const tools = getAllTools();
  const handleToolClick = (toolId) =>
    !isDisabled && onToolSelect && onToolSelect(toolId);

  return (
    <div className="pain-assessment-tool-selector">
      {tools.map((tool) => {
        const isSelected = selectedTool === tool.id;
        return (
          <IconButton
            key={tool.id}
            icon={tool.icon}
            onClick={() => handleToolClick(tool.id)}
            disabled={isDisabled}
            isTogglable={true}
            isToggled={isSelected}
            tooltipContent={tool.name}
            className={`pain-tool-button ${
              isSelected ? "pain-tool-button-selected" : ""
            }`}
            title={tool.name}
          />
        );
      })}
    </div>
  );
};

export default PainAssesmentToolSelector;
